<template>
	<div class="con">
		<div class="nav">
			<div v-for="(item,index) in yearList" class="year" @click="navBtn(index)" :class="[item.id == navIndex ? 'navActive':'']">
				{{item.text}}
			</div>
		</div>
		<div class="list">
			<div id="chart_line"></div>
		</div>
		<div class="list-bot">
			<div class="list-bot-con">
				<div class="num">￥<span>505300</span></div>
				<div>总收入</div>
			</div>
			<div class="list-bot-con">
				<div class="num">￥<span>5050</span></div>
				<div>平均每月</div>
			</div>
			<div class="list-bot-con">
				<div class="num">￥<span>5300</span></div>
				<div>收入最高7月</div>
			</div>
			<div class="list-bot-con">
				<div class="num">￥<span>2300</span></div>
				<div>收入最低1月</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'staIncome',
		data() {
			return {
				yearList: [],
				navIndex: 0,
			}
		},
		methods: {
			
			//折线图
			totalLine() {
				let myChartLine = this.$echarts.init(document.getElementById('chart_line'));

				let option = {
					grid: {
						left: '-8%',
						right: '3%',
						top: '1%',
						bottom: '5%',
						containLabel: true
					},
					tooltip: {
						formatter: '{b}\n{c}'
					},
					xAxis: {
						type: 'category',
						axisLine: { //这是x轴文字颜色
							lineStyle: {
								color: "#fff",
							}
						},

						boundaryGap: false,
						data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
					},

					yAxis: {
						type: 'value',
						show: false,
					},
					series: [{
						data: [820, 932, 901, 934, 800, 700, 626, 875, 946, 786, 763, 687],
						type: 'line',
						symbolSize: 8, //设定实心点的大小
						areaStyle: {
							normal: {
								color: '#27BEC4'
							}
						},
						itemStyle: {
							normal: {
								color: '#27BEC4', //改变折线点的颜色
								lineStyle: {
									color: '#fff' //改变折线颜色
								}
							}
						},

					}]
				};
				myChartLine.setOption(option);
			},
			navBtn(e) {
				this.navIndex = e;
			},
			//头部导航年
			navYear() {
				let newYear = new Date().getFullYear();
				let yearList = [];
				for(let i = 0; i < 3; i++) {
					yearList.push({
						id: i,
						text: newYear - i
					})
				}
				this.yearList = yearList;
			},
		},
		mounted() {
			this.totalLine();
			//			this.totalBar();
			this.navYear();
		},
		created() {

		},
	}
</script>

<style scoped>
	.nav {
		padding: 10px;
		display: flex;
		justify-content: center;
		background-color: #27BEC4;
	}
	
	.year {
		padding: 10px 30px;
		font-size: 15px;
		text-align: center;
		background-color: #fff;
		color: #000;
		border: 1px solid #fff;
	}
	
	.navActive {
		background-color: #27BEC4;
		color: #fff;
		font-weight: 700;
		font-size: 17px;
	}
	
	.head {
		padding: 20px 0;
		background-color: #27BEC4;
		font-size: 15px;
		width: 100%;
		color: #fff;
		text-align: center;
	}
	
	.total-num {
		font-size: 18px;
	}
	
	.list {
		padding: 10px;
		background-color: #27BEC4;
	}
	
	.list-bot {
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
	}
	
	.list-bot-con {
		margin: 1px;
		padding: 20px 0;
		width: 48%;
		font-size: 15px;
		background-color: #fff;
		text-align: center;
	}
	
	.num {
		font-weight: 700;
		color: #666;
	}
	
	.num span {
		font-size: 30px;
	}
	
	#chart_line {
		width: 100%;
		height: 300px;
	}
	
	#chart_bar {
		width: 100%;
		height: 500px;
		margin: 0 auto;
	}
</style>